import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Spinner from '../../utils/Spinner';
import InvoiceRow from './InvoiceRow';
const ClientStripeSubscription = ({ client }) => {
  const [subscription, setSubscription] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    axios.get(`/subscription/v1/get-subscription-info/${client.id}`)
    .then((res) => {
      setSubscription(res.data);
    })
    .finally(() => setIsLoading(false));
  }, []);

  const toLocalString = date => {
    return new Date(date).toLocaleString();
  }
  return <>
    <div>
      {isLoading ?
      <div className="py-4 grid grid-cols-3 px-4">
        <div>
          <Spinner />
        </div>
      </div> 
      :
        <div className="py-4 grid px-4">
          <div>
            <div className="col-span-1"> 
              <h2 className="text-lg font-bold">Subscription Status: 
                <span className="text-md text-gray-500 ">{subscription?.subscriptionStatus}</span>
              </h2>
            </div>
            <div className="col-span-1"> 
              <h2 className="text-lg font-bold">Stripe Subscription ID:
                <span className="text-md text-gray-500">{subscription?.stripeSubscriptionId}</span>
              </h2>
              
            </div>
            <div className="col-span-1"> 
              <h2 className="text-lg font-bold">Stripe Customer ID:
                <span className="text-md text-gray-500">{subscription?.stripeCustomerId}</span>
              </h2>
              
            </div>
            <div className="col-span-1"> 
              <h2 className="text-lg font-bold">Stripe Price ID:
                <span className="text-md text-gray-500">{subscription?.stripePriceId}</span>
              </h2>
              
            </div>
            <div className="col-span-1"> 
              <h2 className="text-lg font-bold">Start Date:
                <span className="text-md text-gray-500">{toLocalString(subscription?.subscriptionStartDate)}</span>
              </h2>
              
            </div>
            <div className="col-span-1"> 
              <h2 className="text-lg font-bold">Pay Period End Date: 
                <span className="text-md text-gray-500">{toLocalString(subscription?.payPeriodEndDate)}</span>
              </h2>
              
            </div>
            <div className="col-span-1"> 
              <h2 className="text-lg font-bold">Current Quantity:
                <span className="text-md text-gray-500">{subscription?.quantity}</span>
              </h2>
            
            </div>
          </div>
          <div className="mx-4 mt-8 overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:-mx-6 md:mx-0 md:rounded-lg w-4/4">
            <table className="table-fixed min-w-full divide-y divide-gray-300">
              <thead className="bg-gray-200">
                <tr>
                  <th
                    scope="col"
                    className="py-3.5 text-left text-sm font-semi-bold text-gray-900 sm:pl-6 w-1/4">
                    Status
                  </th>
                  <th
                    scope="col"
                    className="py-3.5  text-left text-sm font-semi-bold text-gray-900 sm:pl-6 w-1/4">
                    Billing Reason
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3.5 text-left text-sm font-semi-bold text-gray-900 lg:table-cell w-1/4">
                    Collection Method
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3.5 text-left text-sm font-semi-bold text-gray-900 lg:table-cell w-1/4">
                    Created
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3.5 text-left text-sm font-semi-bold text-gray-900 lg:table-cell w-1/4">
                    Invoice Link
                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {subscription?.invoices.map(invoice => (
                  <InvoiceRow key={invoice.id} invoice={invoice}/> 
                ))}
              </tbody>
            </table>
				  </div>
        </div>
        
      }
    </div>
  </> 
};

export default ClientStripeSubscription;